import Fill from "./Fill";

const Button = {
    Fill,
};

export default Button;
